import { axios, getToken, URL_API } from "../../../../../../../utils";

const getHeaders = () => ({ Authorization: "Bearer " + getToken() });

/**
 * Fetch important info records for a partner
 * @param {string} partnerCode
 * @param {number} page
 * @param {number} limit
 */
export const getImportantInfoApi = async (partnerCode, page = 1, limit = 10) => {
  const response = await axios({
    url: `${URL_API}/crm/important-info`,
    headers: getHeaders(),
    method: "get",
    params: {
      partner_code: partnerCode,
      page,
      limit,
    },
  });
  return response.data?.data;
};

/**
 * Create a new important info record
 * @param {object} payload
 */
export const createImportantInfoApi = async (payload) => {
  const response = await axios({
    url: `${URL_API}/crm/important-info`,
    headers: getHeaders(),
    method: "post",
    data: payload,
  });
  return response.data?.data;
};
